import { AppDispatch } from "app/store";
import OmronFooter from "components/OmronFooter";
import OmronHeader from "components/OmronHeader";
import PageTitle from "components/PageTitle";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { initialAsync, selectHasError } from "features/optin";
import { useDispatch, useSelector } from "react-redux";

const OptinCompletePage: React.FC = (): JSX.Element => {
  const dispatch: AppDispatch = useDispatch();
  const { t } = useTranslation();
  const hasError = useSelector(selectHasError);
  // 初期読込
  useEffect(() => {
    dispatch(initialAsync());
  }, [dispatch]);

  return (
    <MainWrapper>
      <OmronHeader
        link={{ path: "/", label: t("common.label.breadcrumbsSignin") }}
        label={[t("common.label.breadcrumbsOptinComplete")]}
      />
      <PageMain>
        <InnerDiv>
          <PageTitle title={t("optinPage.label.title")} text="" />
          <Text>
            {!hasError && t("optinPage.message.info")}
            {hasError && (
              <ErrorComment>{t("optinPage.message.fail")}</ErrorComment>
            )}
          </Text>
        </InnerDiv>
      </PageMain>
      <OmronFooter />
    </MainWrapper>
  );
};

export default OptinCompletePage;

const PageMain = styled.main`
  grid-area: main;
  padding: 3.2rem 50px;
`;

const InnerDiv = styled.div`
  width: 1000px;
  margin: 0 auto;
`;

const MainWrapper = styled.div`
  display: grid;
  grid-template-rows: 76px 40px 1fr auto;
  grid-template-areas:
    "header"
    "breadc"
    "main"
    "footer";
  min-height: 100vh;
`;
const Text = styled.p`
  margin-bottom: 3rem;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
  white-space: pre-wrap;
`;

const ErrorComment = styled.span`
  margin-top: 0.2rem;
  display: block;
  color: #e50000;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
`;
